var _path, _ellipse, _path2, _path3;
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
import * as React from "react";
function SvgChurch6(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 1920,
    height: 1080,
    viewBox: "0 0 1920 1080",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M678 71L678 99",
    stroke: "#F2DCCE",
    strokeWidth: 2
  })), _ellipse || (_ellipse = /*#__PURE__*/React.createElement("ellipse", {
    cx: 678.5,
    cy: 66.3333,
    rx: 16.5,
    ry: 16.3333,
    fill: "#F2DCCE"
  })), _path2 || (_path2 = /*#__PURE__*/React.createElement("path", {
    d: "M673.987 66.1898C673.987 62.2835 677.288 59.1168 681.358 59.1168C681.943 59.1168 682.511 59.1841 683.056 59.3076C681.742 58.4804 680.187 58 678.519 58C673.814 58 670 61.8056 670 66.5C670 71.1944 673.814 75 678.519 75C680.814 75 682.895 74.0929 684.427 72.6205C683.492 73.0317 682.454 73.2628 681.358 73.2628C677.288 73.2628 673.987 70.0961 673.987 66.1898Z",
    fill: "#CC7D61"
  })), _path3 || (_path3 = /*#__PURE__*/React.createElement("path", {
    d: "M687.402 65.6003L687.37 63.1461L685.535 64.7189L683.304 64.0564L684.112 66.3367L682.765 68.3813L685.1 68.2179L686.499 70.144L687.133 67.7627L689.345 66.9085L687.402 65.6003Z",
    fill: "#CC7D61"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgChurch6);
export default __webpack_public_path__ + "static/media/church_6.5c6a360471430d713015c9daa98a6889.svg";
export { ForwardRef as ReactComponent };